export default "__VITE_ASSET__C5t$pNr3__"